import ModelVersionsView from './ModelVersionsView'

export default ModelVersionsView
